import {

    Routes,
    Route,
    Navigate

} from "react-router-dom";

import ProtectedRoute from "../components/auth/ProtectedRoute";

import AppShell from "../components/layout/AppShell";
import Knowledge from "../pages/Knowledge";
import KnowledgePage from "../pages/KnowledgePage";

import Login from "../pages/Login";

import Dashboard from "../pages/v1Dashboard";
import Drive from "../pages/Drive";
import Projects from "../pages/Projects";
import Users from "../pages/Users";
import Roles from "../pages/Roles";
import Activity from "../pages/Activity";
import Search from "../pages/Search";
import Settings from "../pages/Settings";

export default function AppRoutes() {

    return (

        <Routes>

            <Route

                path="/login"

                element={<Login />}

            />
<Route
    path="/knowledge"
    element={<KnowledgePage />}
/>
            <Route

                path="/"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Dashboard />

                        </AppShell>

                    </ProtectedRoute>

                }

            />

            <Route

                path="/dashboard"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Dashboard />

                        </AppShell>

                    </ProtectedRoute>

                }

            />
       <Route

    path="/knowledge"

    element={<Knowledge />}

       />
            <Route

                path="/knowledge"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Knowledge />

                        </AppShell>

                    </ProtectedRoute>

                }

            />

            <Route

                path="/drive"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Drive />

                        </AppShell>

                    </ProtectedRoute>

                }

            />

            <Route

                path="/projects"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Projects />

                        </AppShell>

                    </ProtectedRoute>

                }

            />

            <Route

                path="/users"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Users />

                        </AppShell>

                    </ProtectedRoute>

                }

            />

            <Route

                path="/roles"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Roles />

                        </AppShell>

                    </ProtectedRoute>

                }

            />

            <Route

                path="/activity"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Activity />

                        </AppShell>

                    </ProtectedRoute>

                }

            />

            <Route

                path="/search"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Search />

                        </AppShell>

                    </ProtectedRoute>

                }

            />

            <Route

                path="/settings"

                element={

                    <ProtectedRoute>

                        <AppShell>

                            <Settings />

                        </AppShell>

                    </ProtectedRoute>

                }

            />

            <Route

                path="*"

                element={<Navigate to="/" replace />}

            />

        </Routes>

    );

}